export default [
    {
    	start: 3000,
    	previous: 0,
        scrollDistance: 4600
    },
    {
    	start: 9800,
    	previous: 4600,
        scrollDistance: 13500
    },
    {
    	start: 17300,
    	previous: 13500,
        scrollDistance: 20000
    },
    {
    	start: 24500,
    	previous: 20000,
        scrollDistance: 27100
    },
    {
    	start: 28500,
    	previous: 27100,
        scrollDistance: 29700
    }
];
